<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.codigo }} - {{ $t('descricao') }} : {{ item.descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<div class="container__crudactions__cruddownload__download">
					<!-- <DownloadButton /> -->
				</div>
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVClassificacaoDeSitio()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<InputText
					v-model="model.descricao"
					:label="$t('description')"
					@input="onDescriptionChange"
				/>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('planning')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="goToPlanejamento()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
					<Button
						v-if="descriptionChanged"
						:label="$t('save')"
						color="trv-default"
						@click="update"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../components/Pagination/Pagination'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import {
	createClassificacaoSitio,
	deleteClassificacaoSitioByIdList,
	getAllClassificacaoSitio,
	updateClassificacaoSitio,
} from '../../../services/requests/ClassificacaoSitioRequests'

import { exportarCsv } from '../../../utils/csvHellpers'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Button,
		CrudForm,
		CrudTable,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		KebabMenu,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			intention: {},
			descriptionChanged: false,
			headersSelecionados: [
				'quantidadeDeSitios',
				'nomeDoModelo',
				'formatedData',
				'idadeDeReferencia',
				'descricao',
				'codigo',
			],
			showExclusionAlert: false,
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				codigo: '',
				descricao: '',
				dataDaClassificacao: '',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'CS',
				subtitleCardPropertie: 'descricao',
				titleCardPropertie: 'codigo',
			},
			tableHeaders: [
				{ key: 'codigo', value: this.$t('code'), isActive: true },
				{ key: 'descricao', value: this.$t('description'), isActive: true },
				{
					key: 'idadeDeReferencia',
					value: this.$t('referenceAge'),
					isActive: true,
				},
				{
					key: 'formatedData',
					value: this.$t('classificationDate'),
					isActive: true,
				},
				{ key: 'nomeDoModelo', value: this.$t('model'), isActive: true },
				{
					key: 'quantidadeDeSitios',
					value: this.$t('sites'),
					isActive: true,
				},
			],
		}
	},
	computed: {
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('toView'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.descricao
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	created() {
		this.quantityPerPage = 10
		// this.orderTable = ["codigo"];
		getAllClassificacaoSitio().then(async (response) => {
			var classificacaoSitio = response.data
			classificacaoSitio = await classificacaoSitio.sort((a, b) =>
				new Date(a.dataDaClassificacao).getTime() > new Date(b.dataDaClassificacao).getTime()
					? -1
					: 1,
			)
			const totalRegistros = classificacaoSitio.length
			await classificacaoSitio.forEach((classificacaoSitio, index) =>
				this.formataClassificacaoSitioParaTabela(classificacaoSitio, index, totalRegistros),
			)
			this.modelList = classificacaoSitio
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})
	},
	methods: {
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		createClassificacaoSitioToPost() {
			return {
				id: uuidv4(),
				descricao: this.model.descricao,
				// codigo: this.model.eicb_tx_tipo_modelo,
			}
		},

		onDescriptionChange(value) {
			if (this.isEdit) {
				this.descriptionChanged = this.descricao !== value
				this.disableSaveButton = true
			} else {
				this.disableSaveButton = false
			}
		},

		/**
		 * Cria nova Classificação de Sítio no banco de dados
		 */
		create() {
			const classificacaoSitio = this.createClassificacaoSitioToPost()

			createClassificacaoSitio(classificacaoSitio).then((response) => {
				const { result: classificacaoSitio, isError } = response.data

				this.disableSaveButton = false
				window.location.reload()

				if (!isError) {
					this.cleanModel()
					const totalRegistros = this.modelList.length + 1
					this.formataClassificacaoSitioParaTabela(classificacaoSitio, 0, totalRegistros)

					this.modelList.unshift(classificacaoSitio)

					this.showForm = false
					this.emptyValue = ''

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataClassificacaoSitioParaTabela(classificacaoSitio, index, totalRegistros) {
			classificacaoSitio.isCheckedToDelete = false
			classificacaoSitio.formatedData = classificacaoSitio.dataDaClassificacao
				? new Date(classificacaoSitio.dataDaClassificacao).toLocaleDateString()
				: ''
			classificacaoSitio.codigo = `CS-${String(totalRegistros - index).padStart(2, '0')}`
		},

		/**
		 * Atualiza classificação de sítio no banco de dados
		 */
		update() {
			updateClassificacaoSitio(this.model).then((response) => {
				this.disableSaveButton = false

				if (response.status === 200) {
					this.showForm = false
					this.descriptionChanged = false
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
					window.location.reload()
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui estrato inventario cubagem no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const confirmResult = confirm(this.$t('confirmaExclusao'))

				if (confirmResult) {
					deleteClassificacaoSitioByIdList({
						ids: this.modelsIdWithCheckedToDelete,
					})
						.then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
						.catch((error) => {
							this.mutationShowMessage({
								messageTitle: 'Atenção!',
								messageIcon: 'far fa-times-circle',
								messageType: 'error',
								messageText: error.response.data.errors.Mensagens[0],
							})
						})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		goToPlanejamento() {
			localStorage.setItem('isEdit', this.isEdit)

			localStorage.setItem('item-planejamento-classificacao', JSON.stringify(this.model))
			this.$router.push(`/classificacao/planejamento/${this.model.id}`)
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)
			this.titleForm = `${this.$t('toView')} ${this.$t('siteClassification')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.model.id = uuidv4()
			this.titleForm = `${this.$t('create')} ${this.$t('siteClassification')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.descriptionChanged = false
		},

		/**
		 * Baixa os dados da tabela de classificacao de sitio
		 */
		downloadCSVClassificacaoDeSitio() {
			let cabecalhoDoCsvClassificacaoDeSitio = [
				'Código',
				'Descrição',
				'Idade de Referência',
				'Data da Classificação',
				'Modelo',
				'Sítios',
			]
			const items = this.modelList

			const linhas = items.map((item) => [
				item.codigo,
				item.descricao,
				item.idadeDeReferencia,
				item.dataDaClassificacao,
				item.nomeDoModelo,
				item.quantidadeDeSitios,
			])

			exportarCsv('export_classificacao_de_sitio', cabecalhoDoCsvClassificacaoDeSitio, linhas)
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
